'use client'

import React from 'react'

type Props = {
  options: readonly { value: string; label: string }[]
  value: string
}

/**
 * The "Ordina per" select. It lives in a GET form, so changing it submits the form (keeping
 * `q`); without JavaScript the hidden submit button still does the job.
 */
export const SortSelect: React.FC<Props> = ({ options, value }) => (
  <label className="sortlabel">
    Ordina per{' '}
    <select
      defaultValue={value}
      name="ordina"
      onChange={(event) => event.currentTarget.form?.requestSubmit()}
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  </label>
)
